import dayjs from "dayjs";
import { ICellRendererParams } from 'ag-grid-enterprise';

export const formatAsOfDate = (value) => {
    if ( !value ) {
      return '';
    }
  
    return dayjs(value).format("MMM-YY");
}

export class AsOfDateIdentifierCellRenderer {
    eGui: any;

    init(params: ICellRendererParams) {
      const newDiv = document.createElement('div');
      const leafs = params.node.allLeafChildren;
      let asOfDate = '';
      if (leafs.length > 1) {
        asOfDate = formatAsOfDate(leafs[0].data['asOfDate']);
      }
      newDiv.innerHTML = '<span class="analytics-name">' + asOfDate + '</span>';
      this.eGui = newDiv.firstChild;
    }

    getGui() {
      return this.eGui;
    }
  }

export const AsOfDateValueFormatter =  params => formatAsOfDate(params.value)